"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  paymentFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '40px 76px',
    position: 'sticky',
    bottom: '0',
    boxShadow: "0 -2px 4px 0 ".concat(_theme.default.palette.shadow),
    zIndex: 1,
    fontSize: _theme.default.typography.pxToRem(16),
    fontFamily: _theme.default.typography.proxima.regular,
    color: _theme.default.palette.grayScale.dark,
    '& .MuiLink-button': {
      margin: 0,
      marginLeft: 5,
      fontFamily: _theme.default.typography.proxima.semiBold
    },
    [_theme.default.breakpoints.down('lg')]: {
      padding: 30
    },
    [_theme.default.breakpoints.down('md')]: {
      padding: '20px 32px'
    },
    [_theme.default.breakpoints.down('sm')]: {
      padding: 20,
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  termsWrapper: {
    flexGrow: 1
  },
  summaryWrapper: {
    display: 'flex',
    flexDirection: 'column',
    [_theme.default.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingTop: 10
    }
  },
  tooltip: {
    maxWidth: '500px'
  },
  tooltipWrapper: {
    fontSize: _theme.default.typography.pxToRem(18),
    lineHeight: _theme.default.typography.pxToRem(22),
    display: 'flex',
    alignItems: 'center',
    '& p': {
      fontSize: _theme.default.typography.pxToRem(18),
      lineHeight: _theme.default.typography.pxToRem(22),
      [_theme.default.breakpoints.down('sm')]: {
        fontSize: _theme.default.typography.pxToRem(16),
        lineHeight: _theme.default.typography.pxToRem(19)
      }
    },
    [_theme.default.breakpoints.down('sm')]: {
      fontSize: _theme.default.typography.pxToRem(16),
      lineHeight: _theme.default.typography.pxToRem(19)
    },
    '& .MuiButton-contained': {
      marginLeft: '30px !important'
    }
  },
  checkbox: {
    color: _theme.default.palette.grayScale.main,
    '&.Mui-checked': {
      color: _theme.default.palette.primary.light,
      '& .MuiSvgIcon-root:last-child': {
        transform: 'scale(1.2)'
      }
    }
  },
  customCheckbox: {
    width: '18px',
    height: '18px',
    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px'
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      width: '20px',
      height: '20px'
    }
  },
  element: {
    display: 'block',
    width: 'auto'
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center'
  },
  submitButton: {
    '&.MuiButton-containedPrimary': {
      [_theme.default.breakpoints.up('md')]: {
        marginLeft: '30px'
      },
      [_theme.default.breakpoints.only('md')]: {
        height: '46px'
      },
      [_theme.default.breakpoints.down('sm')]: {
        height: 50,
        width: '100%',
        marginTop: '20px'
      }
    }
  }
});
var _default = exports.default = useStyles;